module.exports = __webpack_public_path__ + "static/media/delete.776dfc66.svg";